// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A single mTLS secret reference returned by the Secrets Manager listing.
 */
export class MtlsSecretRef implements flatbuffers.IUnpackableObject<MtlsSecretRefT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MtlsSecretRef {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMtlsSecretRef(bb: flatbuffers.ByteBuffer, obj?: MtlsSecretRef): MtlsSecretRef {
    return (obj || new MtlsSecretRef()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMtlsSecretRef(
    bb: flatbuffers.ByteBuffer,
    obj?: MtlsSecretRef,
  ): MtlsSecretRef {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MtlsSecretRef()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  arn(): string;
  arn(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  arn(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startMtlsSecretRef(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addArn(builder: flatbuffers.Builder, arnOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, arnOffset, 0);
  }

  static endMtlsSecretRef(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // name
    builder.requiredField(offset, 6); // arn
    return offset;
  }

  static createMtlsSecretRef(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    arnOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MtlsSecretRef.startMtlsSecretRef(builder);
    MtlsSecretRef.addName(builder, nameOffset);
    MtlsSecretRef.addArn(builder, arnOffset);
    return MtlsSecretRef.endMtlsSecretRef(builder);
  }

  unpack(): MtlsSecretRefT {
    return new MtlsSecretRefT(this.name(), this.arn());
  }

  unpackTo(_o: MtlsSecretRefT): void {
    _o.name = this.name();
    _o.arn = this.arn();
  }

  unpackFields(...fields: string[]): MtlsSecretRefT {
    const t = new MtlsSecretRefT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("arn")) {
      t.arn = this.arn();
    }
    return t;
  }
}

export class MtlsSecretRefT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public arn: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    if (this.arn === null || this.arn === undefined) {
      throw new Error('Required field "arn" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const arn = this.arn !== null ? builder.createString(this.arn!) : 0;

    return MtlsSecretRef.createMtlsSecretRef(builder, name, arn);
  }

  clone(): MtlsSecretRefT {
    const obj = new MtlsSecretRefT();
    obj.name = this.name;
    obj.arn = this.arn;
    return obj;
  }

  equals(other: MtlsSecretRefT): boolean {
    if (this.name !== other.name) return false;
    if (this.arn !== other.arn) return false;
    return true;
  }
}

export function verifyMtlsSecretRef(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "arn");
  } finally {
    verifier.popDepth();
  }
}
